import { t } from '../../../common/i18n.js'
import type { Language } from '../../../common/types/i18n.js'
import { getInitialsFromName } from '../../views/portal/utils/format.js'
import './user-bubble.scss'

export interface UserBubbleProps {
    name: string | null
    avatar: string | null
    size?: 'small' | 'medium'
    lang: Language
}

export const UserBubble = ({ name, avatar, size = 'medium', lang }: UserBubbleProps) => {
    return (
        <div className={`user-bubble user-bubble--${size}`}>
            {avatar ? (
                <img
                    className="user-bubble__image"
                    src={avatar}
                    alt={name ?? t.common.userFallback(lang)}
                />
            ) : (
                <div className="user-bubble__placeholder">
                    {name ? getInitialsFromName(name) : '?'}
                </div>
            )}
            {name && <span className="user-bubble__name">{name}</span>}
        </div>
    )
}
